import axiosInstance from 'api/axiosInstance';

export const getIncidentChecklists = async () => {
	const checklistType = 'Incident';
	const url = `/api2.0/Checklist/GetChecklistsByType?checklistType=${checklistType}`;
	const response = await axiosInstance.get(url);
	const incidentChecklists = response.data;
	return incidentChecklists;
};
